<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" template=" <img src='assets/images/spinner.gif' />"></ngx-spinner>
<div class="sfdc-configuration-content" dir="{{languageDir}}">
    <div class="content-top-box">
        <app-bread-crumb></app-bread-crumb>
        <div class="tab-content-top-box">
            <h1 class="main-title">{{langObj ? langObj?.ReactiveMaintenanceMaster : ('ReactiveMaintenanceMaster' |
                translate)}}</h1>
        </div>
    </div>
    <div class="content-top-row content-top-row-order-processing">
        <div class="import_export">
            <button *ngIf="isAccess | permissionChecker" class="import" (click)="openDialog('RM')">
                {{langObj ? langObj?.ImportAsExcel : ('ImportAsExcel' | translate)}}</button>
            <button *ngIf="isAccess | permissionChecker" class="export" (click)="ExportTOExcel('RM')">
                {{langObj ? langObj?.ExportasExcel : ('ExportasExcel' | translate)}}</button>
        </div>
    </div>
    <mat-accordion>
        <!-- Work Order Type -->
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
            <mat-expansion-panel-header class="acc1" class="disable_ripple_acc1">
                <mat-panel-title>
                    {{langObj ? langObj?.WorkOrderType : ('WorkOrderType' | translate)}}
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="wrapper-box wrapper-box-shadow table-wrapper">
                <form [formGroup]="WOTypeForm" #woFormDirective="ngForm" (ngSubmit)="WOTypeSubmit(woFormDirective)">
                    <div class="content-top-row" style="display: flex;">
                        <mat-form-field appearence="fill"
                            class="top-row-first-filed-item top-row-first-filed-item-order-processing">
                            <input matInput formControlName="Name"
                                placeholder="{{langObj ? langObj?.Name : ('Name' | translate)}}"
                                [(ngModel)]="WOType.Name">
                            <mat-error>{{langObj ? langObj?.NameisRequired : ('NameisRequired' |
                                translate)}}</mat-error>
                        </mat-form-field>
                        <button *ngIf="!isEdit && isWrite | permissionChecker" type="submit" class="add-btn1"
                            pTooltip="Save" tooltipPosition="right">
                            <img src="assets/images/save.png" alt="" width="20px" height="20px">
                        </button>
                        <button *ngIf="isEdit && isUpdate | permissionChecker" type="submit" class="add-btn1"
                            pTooltip="Update" tooltipPosition="right">
                            <img src="assets/images/edit.png" alt="" width="20px" height="20px">
                        </button>
                        <button type="reset" class="reset-btn1" pTooltip="Reset" tooltipPosition="right"
                            (click)="reset()">
                            <img src="assets/images/refresh.png" alt="" width="20px" height="20px">
                        </button>
                    </div>
                </form>
                <div class="content-top-row" style="display: flex; justify-content: flex-end;">
                    <mat-form-field appearance="fill" class="field-fill">
                        <mat-label>{{langObj ? langObj?.Search : ('Search' | translate)}}</mat-label>
                        <input [readonly]="false" matInput (keyup)="applyWOTypeFilter($event)" class="input-text"
                            autocomplete="off" />
                    </mat-form-field>
                </div>

                <div class="content-row-flex-both-end" #WOTypeTable>
                    <table mat-table #wotypetable class="basic-table plant-model-table" matSort
                        [dataSource]="WOTypeDataSource">

                        <ng-container matColumnDef="ID">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                <p class="header-text">S.NO</p>
                            </th>
                            <td mat-cell *matCellDef="let element; let i = index">{{ (WOTypePage.pageIndex *
                                WOTypePage.pageSize) + i + 1}}</td>
                        </ng-container>

                        <ng-container matColumnDef="Name">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                <p class="header-text">{{langObj ? langObj?.Name : ('Name' | translate)}}</p>
                            </th>
                            <td mat-cell *matCellDef="let element">{{element.Name}}</td>
                        </ng-container>

                        <ng-container matColumnDef="CreatedAt">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                <p class="header-text">{{langObj ? langObj?.CreationDate : ('CreationDate' |
                                    translate)}}</p>
                            </th>
                            <td mat-cell *matCellDef="let element">{{element.CreatedAt | date: 'dd-MM-yyyy hh:mm:ss a'}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="CreatedBy">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                <p class="header-text">{{langObj ? langObj?.CreatedBy : ('CreatedBy' | translate)}}</p>
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{element.CreatedUser}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef>
                                <p class="header-text">{{langObj ? langObj?.Actions : ('Actions' | translate)}}</p>
                            </th>
                            <td mat-cell *matCellDef="let element; let i = index" class="row-action-btns-column">
                                <div class="row-action-btns">
                                    <button mat-icon-button *ngIf="isUpdate | permissionChecker" class="edit-btn"
                                        aria-label="Edit Row" (click)="editWOType(element)">
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M0.75 9.06298V11.2505H2.9375L9.38917 4.79881L7.20167 2.61131L0.75 9.06298ZM11.0808 3.10715C11.3083 2.87965 11.3083 2.51215 11.0808 2.28465L9.71583 0.919648C9.48833 0.692148 9.12083 0.692148 8.89333 0.919648L7.82583 1.98715L10.0133 4.17465L11.0808 3.10715Z"
                                                fill="white" />
                                        </svg>
                                    </button>
                                    <button mat-icon-button *ngIf="isDelete | permissionChecker" class="tree-view-btn"
                                        aria-label="View Row Tree" (click)="deleteWOType(element)">
                                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M0 10C0 4.47715 4.47715 0 10 0H24C29.5228 0 34 4.47715 34 10V24C34 29.5228 29.5228 34 24 34H10C4.47715 34 0 29.5228 0 24V10Z"
                                                fill="#F85439" />
                                            <circle cx="17" cy="17" r="14" fill="#F85439" />
                                            <path
                                                d="M20.9157 12.2611H18.874L18.2907 11.6777H15.374L14.7907 12.2611H12.749V13.4277H20.9157V12.2611ZM13.3324 21.0111C13.3324 21.3205 13.4553 21.6172 13.6741 21.836C13.8929 22.0548 14.1896 22.1777 14.499 22.1777H19.1657C19.4751 22.1777 19.7719 22.0548 19.9906 21.836C20.2094 21.6172 20.3324 21.3205 20.3324 21.0111V14.0111H13.3324V21.0111Z"
                                                fill="white" />
                                        </svg>
                                    </button>
                                </div>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="WOTypeColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: WOTypeColumns"></tr>
                    </table>
                </div>
                <div class="table-bottom">
                    <mat-paginator class="basic-paginataor" [length]="WOTypePage.length"
                        [pageIndex]="WOTypePage.pageIndex" [pageSizeOptions]="pageSizeOptions"
                        (page)="customePaginator($event,'wotype')" showFirstLastButtons></mat-paginator>
                </div>
            </div>
        </mat-expansion-panel>

        <!--FailureMode-->
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
            <mat-expansion-panel-header class="acc4" class="disable_ripple_acc4">
                <mat-panel-title>
                    {{langObj ? langObj?.FailureMode : ('FailureMode' | translate)}}
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="wrapper-box wrapper-box-shadow table-wrapper">
                <form [formGroup]="FailureModeForm" #fmFormDirective="ngForm"
                    (ngSubmit)="FailureModeOnSubmit(fmFormDirective)">
                    <div class="content-top-row d-flex">
                        <mat-form-field appearence="fill"
                            class="top-row-first-filed-item top-row-first-filed-item-order-processing">
                            <input matInput formControlName="FailureMode"
                                placeholder="{{langObj ? langObj?.FailureMode : ('FailureMode' | translate)}}"
                                [(ngModel)]="FailureMode.Name">
                            <mat-error>{{langObj ? langObj?.FailureModeisRequired : ('FailureModeisRequired' |
                                translate)}}</mat-error>
                        </mat-form-field>
                        <mat-form-field appearence="fill"
                            class="top-row-first-filed-item top-row-first-filed-item-order-processing">
                            <mat-select
                                placeholder="{{langObj ? langObj?.WorkOrderType : ('WorkOrderType' | translate)}}"
                                [(ngModel)]="FailureMode.WOType" formControlName="woType">
                                <mat-select-filter [placeholder]="'Search'" [displayMember]="'Name'"
                                    [array]="WOTypeList" (filteredReturn)="WOTypeFiltList = $event">
                                </mat-select-filter>
                                <mat-option *ngFor="let woType of WOTypeFiltList" [value]="woType.ID">
                                    {{woType.Name }}
                                </mat-option>
                            </mat-select>
                            <mat-error>{{langObj ? langObj?.WorkOrderTypeisRequired : ('WorkOrderTypeisRequired' |
                                translate)}}</mat-error>
                        </mat-form-field>
                        <button *ngIf="!edited && isWrite | permissionChecker" type="submit" class="add-btn1"
                            pTooltip="Save" tooltipPosition="right">
                            <img src="assets/images/save.png" alt="" width="20px" height="20px">
                        </button>
                        <button *ngIf="edited && isUpdate | permissionChecker" type="submit" class="add-btn1"
                            pTooltip="Update" tooltipPosition="right">
                            <img src="assets/images/edit.png" alt="" width="20px" height="20px">
                        </button>
                        <button type="reset" class="reset-btn1" pTooltip="Reset" tooltipPosition="right"
                            (click)="reset()">
                            <img src="assets/images/refresh.png" alt="" width="20px" height="20px">
                        </button>
                    </div>
                </form>

                <div class="content-top-row" style="display: flex; justify-content: flex-end;">
                    <mat-form-field appearance="fill" class="field-fill">
                        <mat-label>{{langObj ? langObj?.Search : ('Search' | translate)}}</mat-label>
                        <input [readonly]="false" matInput (keyup)="applyFailureFilter($event)" class="input-text"
                            autocomplete="off" />
                    </mat-form-field>
                </div>

                <div class="content-row-flex-both-end" #FailureModeTable>
                    <table mat-table #failuremodetable class="basic-table plant-model-table" matSort
                        [dataSource]="failureModeTableDataSource">

                        <ng-container matColumnDef="ID">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                <p class="header-text">S.NO</p>
                            </th>
                            <td mat-cell *matCellDef="let element; let i = index">{{ (page.pageIndex * page.pageSize) +
                                i + 1}}</td>
                        </ng-container>

                        <ng-container matColumnDef="Name">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                <p class="header-text">{{langObj ? langObj?.FailureMode : ('FailureMode' | translate)}}
                                </p>
                            </th>
                            <td mat-cell *matCellDef="let element">{{element.Name}}</td>
                        </ng-container>

                        <ng-container matColumnDef="WOType">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                <p class="header-text">{{langObj ? langObj?.WorkOrderType : ('WorkOrderType' |
                                    translate)}}</p>
                            </th>
                            <td mat-cell *matCellDef="let element">{{element.WOType ? element.WOType.Name : ''}}</td>
                        </ng-container>

                        <ng-container matColumnDef="CreatedAt">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                <p class="header-text">{{langObj ? langObj?.CreationDate : ('CreationDate' |
                                    translate)}}</p>
                            </th>
                            <td mat-cell *matCellDef="let element">{{element.CreatedAt | date: 'dd-MM-yyyy hh:mm:ss a'}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="CreatedBy">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                <p class="header-text">{{langObj ? langObj?.CreatedBy : ('CreatedBy' | translate)}}</p>
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{element.CreatedUser}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef>
                                <p class="header-text">{{langObj ? langObj?.Actions : ('Actions' | translate)}}</p>
                            </th>
                            <td mat-cell *matCellDef="let element; let i = index" class="row-action-btns-column">
                                <div class="row-action-btns">
                                    <button mat-icon-button *ngIf="isUpdate | permissionChecker" class="edit-btn"
                                        aria-label="Edit Row" (click)="editFailureRow(element)">
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M0.75 9.06298V11.2505H2.9375L9.38917 4.79881L7.20167 2.61131L0.75 9.06298ZM11.0808 3.10715C11.3083 2.87965 11.3083 2.51215 11.0808 2.28465L9.71583 0.919648C9.48833 0.692148 9.12083 0.692148 8.89333 0.919648L7.82583 1.98715L10.0133 4.17465L11.0808 3.10715Z"
                                                fill="white" />
                                        </svg>
                                    </button>
                                    <button mat-icon-button *ngIf="isDelete | permissionChecker" class="tree-view-btn"
                                        aria-label="View Row Tree" (click)="deleteFailureRow(element)">
                                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M0 10C0 4.47715 4.47715 0 10 0H24C29.5228 0 34 4.47715 34 10V24C34 29.5228 29.5228 34 24 34H10C4.47715 34 0 29.5228 0 24V10Z"
                                                fill="#F85439" />
                                            <circle cx="17" cy="17" r="14" fill="#F85439" />
                                            <path
                                                d="M20.9157 12.2611H18.874L18.2907 11.6777H15.374L14.7907 12.2611H12.749V13.4277H20.9157V12.2611ZM13.3324 21.0111C13.3324 21.3205 13.4553 21.6172 13.6741 21.836C13.8929 22.0548 14.1896 22.1777 14.499 22.1777H19.1657C19.4751 22.1777 19.7719 22.0548 19.9906 21.836C20.2094 21.6172 20.3324 21.3205 20.3324 21.0111V14.0111H13.3324V21.0111Z"
                                                fill="white" />
                                        </svg>
                                    </button>
                                </div>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="failuremodeColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: failuremodeColumns"></tr>
                    </table>
                </div>
                <div class="table-bottom">
                    <mat-paginator class="basic-paginataor" [length]="page.length" [pageIndex]="page.pageIndex"
                        [pageSizeOptions]="pageSizeOptions" (page)="customePaginator($event,'failuremode')"
                        showFirstLastButtons>
                    </mat-paginator>
                </div>
            </div>
        </mat-expansion-panel>

        <!-- Priority -->
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
            <mat-expansion-panel-header class="acc1" class="disable_ripple_acc1">
                <mat-panel-title>
                    {{langObj ? langObj?.Priority : ('Priority' | translate)}}
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="wrapper-box wrapper-box-shadow table-wrapper">
                <form [formGroup]="PriorityForm" #priorityFormDirective="ngForm"
                    (ngSubmit)="PrioritySubmit(priorityFormDirective)">
                    <div class="content-top-row" style="display: flex;">
                        <mat-form-field appearence="fill"
                            class="top-row-first-filed-item top-row-first-filed-item-order-processing">
                            <input matInput formControlName="Name"
                                placeholder="{{langObj ? langObj?.Name : ('Name' | translate)}}"
                                [(ngModel)]="Priority.Name">
                            <mat-error>{{langObj ? langObj?.NameisRequired : ('NameisRequired' |
                                translate)}}</mat-error>
                        </mat-form-field>
                        <div style="display: flex; align-items: center;margin-left: 15px;">
                            <mat-label style="font-weight: 700; font-size: 13px;">Choose Color </mat-label>
                            <p-colorPicker style="margin-left: 15px;" formControlName="Color"></p-colorPicker>
                        </div>
                        <button *ngIf="!isEdit && isWrite | permissionChecker" type="submit" class="add-btn1"
                            pTooltip="Save" tooltipPosition="right">
                            <img src="assets/images/save.png" alt="" width="20px" height="20px">
                        </button>
                        <button *ngIf="isEdit && isUpdate | permissionChecker" type="submit" class="add-btn1"
                            pTooltip="Update" tooltipPosition="right">
                            <img src="assets/images/edit.png" alt="" width="20px" height="20px">
                        </button>
                        <button type="reset" class="reset-btn1" pTooltip="Reset" tooltipPosition="right"
                            (click)="reset()">
                            <img src="assets/images/refresh.png" alt="" width="20px" height="20px">
                        </button>
                    </div>
                </form>
                <div class="content-top-row" style="display: flex; justify-content: flex-end;">
                    <mat-form-field appearance="fill" class="field-fill">
                        <mat-label>{{langObj ? langObj?.Search : ('Search' | translate)}} </mat-label>
                        <input [readonly]="false" matInput (keyup)="applyPriorityFilter($event)" class="input-text"
                            autocomplete="off" />
                    </mat-form-field>
                </div>

                <div class="content-row-flex-both-end" #PriorityTable>
                    <table mat-table #prioritytable class="basic-table plant-model-table" matSort
                        [dataSource]="PrioritySource">

                        <ng-container matColumnDef="ID">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                <p class="header-text">S.NO</p>
                            </th>
                            <td mat-cell *matCellDef="let element; let i = index">{{ (PriorityPage.pageIndex *
                                PriorityPage.pageSize) + i + 1}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="Name">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                <p class="header-text">{{langObj ? langObj?.Name : ('Name' | translate)}} </p>
                            </th>
                            <td mat-cell *matCellDef="let element">{{element.Name}}</td>
                        </ng-container>

                        <ng-container matColumnDef="Color">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                <p class="header-text">Color</p>
                            </th>
                            <td mat-cell *matCellDef="let element" [style.background-color]="element.Color"
                                [style.color]="getTextColor(element.Color)" [style.font-weight]="'900'">
                                {{ element.Color }}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="CreatedAt">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                <p class="header-text">{{langObj ? langObj?.CreationDate : ('CreationDate' |
                                    translate)}}</p>
                            </th>
                            <td mat-cell *matCellDef="let element">{{element.CreatedAt | date: 'dd-MM-yyyy hh:mm:ss a'}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="CreatedBy">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                <p class="header-text">{{langObj ? langObj?.CreatedBy : ('CreatedBy' | translate)}}</p>
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{element.CreatedUser}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef>
                                <p class="header-text">{{langObj ? langObj?.Actions : ('Actions' | translate)}}</p>
                            </th>
                            <td mat-cell *matCellDef="let element; let i = index" class="row-action-btns-column">
                                <div class="row-action-btns">
                                    <button mat-icon-button *ngIf="isUpdate | permissionChecker" class="edit-btn"
                                        aria-label="Edit Row" (click)="editPriority(element)">
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M0.75 9.06298V11.2505H2.9375L9.38917 4.79881L7.20167 2.61131L0.75 9.06298ZM11.0808 3.10715C11.3083 2.87965 11.3083 2.51215 11.0808 2.28465L9.71583 0.919648C9.48833 0.692148 9.12083 0.692148 8.89333 0.919648L7.82583 1.98715L10.0133 4.17465L11.0808 3.10715Z"
                                                fill="white" />
                                        </svg>
                                    </button>
                                    <button mat-icon-button *ngIf="isDelete | permissionChecker" class="tree-view-btn"
                                        aria-label="View Row Tree" (click)="deletePriority(element)">
                                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M0 10C0 4.47715 4.47715 0 10 0H24C29.5228 0 34 4.47715 34 10V24C34 29.5228 29.5228 34 24 34H10C4.47715 34 0 29.5228 0 24V10Z"
                                                fill="#F85439" />
                                            <circle cx="17" cy="17" r="14" fill="#F85439" />
                                            <path
                                                d="M20.9157 12.2611H18.874L18.2907 11.6777H15.374L14.7907 12.2611H12.749V13.4277H20.9157V12.2611ZM13.3324 21.0111C13.3324 21.3205 13.4553 21.6172 13.6741 21.836C13.8929 22.0548 14.1896 22.1777 14.499 22.1777H19.1657C19.4751 22.1777 19.7719 22.0548 19.9906 21.836C20.2094 21.6172 20.3324 21.3205 20.3324 21.0111V14.0111H13.3324V21.0111Z"
                                                fill="white" />
                                        </svg>
                                    </button>
                                </div>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="PriorityColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: PriorityColumns"></tr>
                    </table>
                </div>
                <div class="table-bottom">
                    <mat-paginator class="basic-paginataor" [length]="PriorityPage.length"
                        [pageIndex]="PriorityPage.pageIndex" [pageSizeOptions]="pageSizeOptions"
                        (page)="customePaginator($event,'priority')" showFirstLastButtons></mat-paginator>
                </div>
            </div>
        </mat-expansion-panel>

        <!-- DelayTime-->
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
            <mat-expansion-panel-header class="acc4" class="disable_ripple_acc4">
                <mat-panel-title>
                    {{langObj ? langObj?.DelayTime : ('DelayTime' | translate)}}
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="wrapper-box wrapper-box-shadow table-wrapper">
                <form [formGroup]="TimeForm" #delayTimeFormDirective="ngForm"
                    (ngSubmit)="TimeOnSubmit(delayTimeFormDirective)">
                    <div class="content-top-row" style="display: flex;">
                        <mat-form-field appearence="fill"
                            class="top-row-first-filed-item top-row-first-filed-item-order-processing">
                            <input matInput type="number" formControlName="time"
                                placeholder="{{langObj ? langObj?.EnterNumberInMinutes : ('EnterNumberInMinutes' | translate)}}"
                                [(ngModel)]="Time.TimeLimit">
                            <mat-error>{{langObj ? langObj?.TimeLimitIsRequired : ('TimeLimitIsRequired' |
                                translate)}}</mat-error>
                        </mat-form-field>
                        <p class="min">&nbsp;&nbsp;&nbsp; / {{langObj ? langObj?.Min : ('Min' | translate)}} &nbsp;</p>
                        <button *ngIf="!edited && isWrite | permissionChecker" type="submit" class="add-btn1"
                            pTooltip="Save" tooltipPosition="right">
                            <img src="assets/images/save.png" alt="" width="20px" height="20px">
                        </button>
                        <button *ngIf="edited && isUpdate | permissionChecker" type="submit" class="add-btn1"
                            pTooltip="Update" tooltipPosition="right">
                            <img src="assets/images/edit.png" alt="" width="20px" height="20px">
                        </button>
                        <button type="reset" class="reset-btn1" pTooltip="Reset" tooltipPosition="right"
                            (click)="reset()">
                            <img src="assets/images/refresh.png" alt="" width="20px" height="20px">
                        </button>
                    </div>
                </form>

                <div class="content-top-row" style="display: flex; justify-content: flex-end;">
                    <mat-form-field appearance="fill" class="field-fill">
                        <mat-label>{{langObj ? langObj?.Search : ('Search' | translate)}}</mat-label>
                        <input [readonly]="false" matInput (keyup)="applyTimeFilter($event)" class="input-text"
                            autocomplete="off" />
                    </mat-form-field>
                </div>

                <div class="content-row-flex-both-end" #TimeTable>
                    <table mat-table #timetable class="basic-table plant-model-table" matSort
                        [dataSource]="timeTableDataSource">

                        <ng-container matColumnDef="TimeLimit">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                <p class="header-text">{{langObj ? langObj?.TimeByMinutes : ('TimeByMinutes' |
                                    translate)}}</p>
                            </th>
                            <td mat-cell *matCellDef="let element">{{element.TimeLimit}}</td>
                        </ng-container>

                        <ng-container matColumnDef="CreatedAt">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                <p class="header-text">{{langObj ? langObj?.CreationDate : ('CreationDate' |
                                    translate)}}</p>
                            </th>
                            <td mat-cell *matCellDef="let element">{{element.CreatedAt | date: 'dd-MM-yyyy hh:mm:ss a'}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="CreatedBy">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                <p class="header-text">{{langObj ? langObj?.CreatedBy : ('CreatedBy' | translate)}}</p>
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{element.CreatedUser}}

                            </td>
                        </ng-container>

                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef>
                                <p class="header-text">{{langObj ? langObj?.Actions : ('Actions' | translate)}}</p>
                            </th>
                            <td mat-cell *matCellDef="let element; let i = index" class="row-action-btns-column">
                                <div class="row-action-btns">
                                    <button mat-icon-button *ngIf="isUpdate | permissionChecker" class="edit-btn"
                                        aria-label="Edit Row" (click)="editTimeRow(element)">
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M0.75 9.06298V11.2505H2.9375L9.38917 4.79881L7.20167 2.61131L0.75 9.06298ZM11.0808 3.10715C11.3083 2.87965 11.3083 2.51215 11.0808 2.28465L9.71583 0.919648C9.48833 0.692148 9.12083 0.692148 8.89333 0.919648L7.82583 1.98715L10.0133 4.17465L11.0808 3.10715Z"
                                                fill="white" />
                                        </svg>
                                    </button>
                                </div>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="timeColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: timeColumns"></tr>
                    </table>
                </div>
                <div class="table-bottom">
                    <mat-paginator class="basic-paginataor" [pageSizeOptions]="[5, 10, 20]"
                        (page)="customePaginator($event,'time')" showFirstLastButtons></mat-paginator>
                </div>
            </div>
        </mat-expansion-panel>

        <!-- AssignedTechnicians -->
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
            <mat-expansion-panel-header class="acc1" class="disable_ripple_acc1">
                <mat-panel-title>
                    {{langObj ? langObj?.Technician : ('Technician' | translate)}}
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="wrapper-box wrapper-box-shadow table-wrapper">
                <form [formGroup]="TechnicianForm">
                    <div class="content-top-row" style="display: flex;">


                        <mat-form-field class="selectTech">
                            <mat-label>{{langObj ? langObj?.AssignTechnician : ('AssignTechnician' |
                                translate)}}</mat-label>

                            <mat-select ngxMatSelect #msUser="ngxMatSelect" [displayMember]="'fullName'"
                                [valueMember]="'employeeCode'" [source]="raci" [useInfiniteScroll]="true"
                                formControlName="Name" [multiple]="true" (openedChange)="openedChange($event)"
                                [(ngModel)]="Technician.Name" [placeholder]="'Select Users'">
                                <mat-option *ngFor="let user of msUser.filteredSource" [value]="user.employeeCode">
                                    {{user.fullName}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>


                        <button *ngIf="isWrite | permissionChecker" (click)="TechnicianSubmit()" class="add-btn1"
                            pTooltip="Save" tooltipPosition="right">
                            <img src="assets/images/save.png" alt="" width="20px" height="20px">
                        </button>
                        <button type="reset" class="reset-btn1" pTooltip="Reset" tooltipPosition="right"
                            (click)="reset()">
                            <img src="assets/images/refresh.png" alt="" width="20px" height="20px">
                        </button>
                    </div>
                </form>
            </div>
        </mat-expansion-panel>

        <!-- BreakdownConfigurationPanel -->
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
            <mat-expansion-panel-header class="acc4" class="disable_ripple_acc4">
                <mat-panel-title>
                    {{langObj ? langObj?.BreakdownConfiguration : ('BreakdownConfiguration' | translate)}}
                </mat-panel-title>
            </mat-expansion-panel-header>
            <form [formGroup]="breakdownForm" #breakdownFormDirective="ngForm"
                (ngSubmit)="onSubmitBreakdownForm(breakdownFormDirective)"
                style="margin-top: 30px; margin-bottom: 30px;">
                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="40px">
                    <fieldset class="fieldsetss" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
                        <legend>{{langObj ? langObj?.Minor : ('Minor' | translate)}} <span
                                style="font-size: x-small;">in mins</span></legend>
                        <mat-form-field appearence="fill" style="width: 150px">
                            <input type="number" matInput formControlName="minorMin"
                                placeholder="{{langObj ? langObj?.Min : ('Min' | translate)}}">
                            <mat-error>{{langObj ? langObj?.MinorMinisRequired : ('MinorMinisRequired' |
                                translate)}}</mat-error>
                        </mat-form-field>
                        <mat-form-field appearence="fill" style="width: 150px">
                            <input type="number" matInput formControlName="minorMax"
                                placeholder="{{langObj ? langObj?.Max : ('Max' | translate)}}">
                            <mat-error>{{langObj ? langObj?.MinorMaxisRequired : ('MinorMaxisRequired' |
                                translate)}}</mat-error>
                        </mat-form-field>
                    </fieldset>
                    <fieldset class="fieldsetss" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
                        <legend>{{langObj ? langObj?.Moderate : ('Moderate' | translate)}} <span
                                style="font-size: x-small;">in mins</span></legend>
                        <mat-form-field appearence="fill" style="width: 150px">
                            <input type="number" matInput formControlName="moderateMin"
                                placeholder="{{langObj ? langObj?.Min : ('Min' | translate)}}">
                            <mat-error>{{langObj ? langObj?.ModerateMinisRequired : ('ModerateMinisRequired' |
                                translate)}}</mat-error>
                        </mat-form-field>
                        <mat-form-field appearence="fill" style="width: 150px">
                            <input type="number" matInput formControlName="moderateMax"
                                placeholder="{{langObj ? langObj?.Max : ('Max' | translate)}}">
                            <mat-error>{{langObj ? langObj?.ModerateMaxisRequired : ('ModerateMaxisRequired' |
                                translate)}}</mat-error>
                        </mat-form-field>
                    </fieldset>
                    <fieldset class="fieldsetss" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
                        <legend>{{langObj ? langObj?.Major : ('Major' | translate)}} <span
                                style="font-size: x-small;">in mins</span></legend>
                        <mat-form-field appearence="fill" style="width: 150px">
                            <input type="number" matInput formControlName="majorMin"
                                placeholder="{{langObj ? langObj?.Min : ('Min' | translate)}}">
                            <mat-error>{{langObj ? langObj?.MajorMinisRequired : ('MajorMinisRequired' |
                                translate)}}</mat-error>
                        </mat-form-field>
                        <!-- <mat-form-field appearence="fill" style="width: 150px">
                            <input type="number" matInput formControlName="majorMax"
                                placeholder="{{langObj ? langObj?.Max : ('Max' | translate)}}">
                            <mat-error>{{langObj ? langObj?.MajorMaxisRequired : ('MajorMaxisRequired' |
                                translate)}}</mat-error>
                        </mat-form-field> -->
                    </fieldset>
                    <div fxLayout="row" fxLayoutAlign="center center">
                        <button *ngIf="!isBreakdownEdit && isWrite | permissionChecker" type="submit" class="add-btn1"
                            pTooltip="Save" tooltipPosition="right">
                            <img src="assets/images/save.png" alt="" width="20px" height="20px">
                        </button>
                        <button *ngIf="isBreakdownEdit && isUpdate | permissionChecker" type="submit" class="add-btn1"
                            pTooltip="Update" tooltipPosition="right">
                            <img src="assets/images/edit.png" alt="" width="20px" height="20px">
                        </button>
                    </div>
                </div>
            </form>

            <div class="grid">
                <ag-grid-angular style="width: 100%; height: 24vw;" class="ag-theme-alpine" [rowData]="rowData"
                    [columnDefs]="columnDefs" (gridReady)="onGridReady($event)"
                    [frameworkComponents]="frameworkComponents" [gridOptions]="gridOptions" [pagination]="true"
                    [paginationPageSize]="10">
                </ag-grid-angular>
            </div>
        </mat-expansion-panel>


    </mat-accordion>

</div>